import { TdsGlobalHeader } from '@trv-tds/react'

const Header = () => (
  <TdsGlobalHeader
    role='banner'
    homehref="https://travelers.com/"
    homelabel="Home"
  />
)

export { Header }
